import HomeIcon from "@mui/icons-material/Home";
import LanguageIcon from "@mui/icons-material/Language";
import NotificationsIcon from "@mui/icons-material/Notifications";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import SummarizeIcon from "@mui/icons-material/Summarize";
import SettingsIcon from "@mui/icons-material/Settings";
// import AccountBoxIcon from "@mui/icons-material/AccountBox";
import KeyIcon from "@mui/icons-material/Key";
import LoopIcon from "@mui/icons-material/Loop";

//====================== SUPER Admin =======================//
export const allSuperAdminViews = {
  license: "license-admin",
  dashboard: "dashboard",
  changeRequests: "change-requests",
};

export const superAdminRoutes = [
  "/admin/license",
  "/admin/change-requests",
  "/admin",
];

export const superAdminMenu = [
  {
    id: allSuperAdminViews.dashboard,
    icon: <HomeIcon fontSize="small" />,
    name: "Dashboard",
    path: "/admin",
  },
  {
    id: allSuperAdminViews.license,
    icon: <KeyIcon fontSize="small" />,
    name: "License Generation",
    path: "/admin/license",
  },
  {
    id: allSuperAdminViews.changeRequests,
    icon: <LoopIcon fontSize="small" />,
    name: "Change Requests",
    path: "/admin/change-requests",
  },
];

//===================== BANK ADMIN ======================//
export const bankAdminViews = {
  overview: "overview",
  "admin-tool": "admin-tool",
  "bank-settings": "bank-settings",
  "search-archive-settings": "search-archive-settings",
  "alerts-notifications": "alerts-notifications",

  swift: "swift",
  "swift-day": "swift-day",
  "swift-search": "swift-search",

  license: "license",
  "license-modules": "license-modules",

  reports: "reports",
  "Alerts&Notifications": "Alerts&Notifications",
  "alerts-settings": "alerts-settings",
  "internal-alerts": "internal-alerts",
  "generated-notifications": "generated-notifications",
  "customers-list": "customers-list",
  "customers-groups": "customers-groups",
  matching: "matching",
  "matching-rules": "matching-rules",
  "matching-day": "matching-day",
};

export const bankAdminRoutes = [
  "/",

  "/admin-tool/bank-settings",
  "/admin-tool/alerts-notifications",
  "/admin-tool/search-archive",
  "/swift-day",
  "/swift-search",
  "/reports",

  "/alerts-settings",
  "/internal-alerts",
  "/generated-notifications",
  "/customers-list",
  "/customers-groups",
  "/license",
  "/license/modules",

  "/matching-day",
  "/matching-rules",

  // "/user-management/users",
];

//===================== BANK USER ======================//
export const bankUserViews = {
  overview: "overview",

  swift: "swift",
  "swift-day": "swift-day",
  "swift-search": "swift-search",

  // license: "license",
  // "license-modules": "license-modules",

  reports: "reports",
  "Alerts&Notifications": "Alerts&Notifications",
  "alerts-settings": "alerts-settings",
  "internal-alerts": "internal-alerts",
  "generated-notifications": "generated-notifications",
  "customers-list": "customers-list",
  "customers-groups": "customers-groups",
  matching: "matching",
  "matching-rules": "matching-rules",
  "matching-day": "matching-day",
};

export const bankUserRoutes = [
  "/",

  "/swift-day",
  "/swift-search",
  "/reports",
  "/alerts-settings",
  "/internal-alerts",
  "/generated-notifications",
  "/customers-list",
  "/customers-groups",
  // "/license",
  // "/license/modules",

  // "/user-management/users",

  "/matching-day",
  "/matching-rules",
];

//===================== MAIN MENUES ====================//
export const allBankViews = {
  overview: "overview",
  "admin-tool": "admin-tool",
  "bank-settings": "bank-settings",
  "search-archive-settings": "search-archive-settings",
  "alerts-notifications": "alerts-notifications",

  swift: "swift",
  "swift-day": "swift-day",
  "swift-search": "swift-search",

  license: "license",
  "license-modules": "license-modules",

  reports: "reports",

  "Alerts&Notifications": "Alerts&Notifications",
  "alerts-settings": "alerts-settings",
  "internal-alerts": "internal-alerts",
  "generated-notifications": "generated-notifications",
  "customers-list": "customers-list",
  "customers-groups": "customers-groups",
  matching: "matching",
  "matching-rules": "matching-rules",
  "matching-day": "matching-day",
};

export const MainMenu = [
  {
    id: allBankViews["overview"],
    icon: <HomeIcon fontSize="small" />,
    name: "Overview",
    path: "/",
    category: "modules",
  },
  {
    id: allBankViews["swift"],
    icon: <LanguageIcon fontSize="small" />,
    name: "SWIFT",
    path: "/swift-day",
    category: "modules",
  },
  {
    id: allBankViews["Alerts&Notifications"],
    icon: <NotificationsIcon fontSize="small" />,
    name: "Alerts&Notifications",
    path: "/alerts-settings",
    category: "modules",
  },
  {
    id: allBankViews["matching"],
    icon: <SwapHorizIcon fontSize="small" />,
    name: "Matching",
    path: "/matching-rules",
    category: "modules",
  },

  {
    id: allBankViews["reports"],
    icon: <SummarizeIcon fontSize="small" />,
    name: "Reporting",
    path: "/reports",
    category: "modules",
  },
  {
    id: allBankViews["admin-tool"],
    icon: <SettingsIcon fontSize="small" />,
    name: "Admin Tool",
    nestedList: [
      {
        id: "Bank Settings",
        name: "Bank Settings",
        path: "admin-tool/bank-settings",
      },
      {
        id: "Alerts & Notifications",
        name: "Alerts & Notifications",
        path: "admin-tool/alerts-notifications",
      },
      {
        id: "Search & Archive",
        name: "Search & Archive",
        path: "admin-tool/search-archive",
      },
    ],
    category: "settings",
  },
  {
    id: "User Management",
    icon: "",
    name: "User Management",
    nestedList: [
      {
        id: "Users",
        name: "Users",
        path: "user-management/users",
      },
    ],
  },
  {
    id: allBankViews["license"],
    icon: <KeyIcon fontSize="small" />,
    name: "License",
    path: "/license",
    category: "settings",
  },
];

export const SwiftMenu = [
  {
    id: allBankViews["swift-day"],
    name: "SWIFT Day",
    path: "/swift-day",
  },
  {
    id: allBankViews["swift-search"],
    name: "SWIFT Search",
    path: "/swift-search",
  },
];
export const SwiftRoutes = ["/swift-day", "/swift-search"];

export const AlertsMenu = [
  {
    id: allBankViews["alerts-settings"],
    name: "Alerts Settings",
    path: "/alerts-settings",
  },
  {
    id: allBankViews["internal-alerts"],
    name: "Following on Internal Alerts",
    path: "/internal-alerts",
  },
  {
    id: allBankViews["customers-list"],
    name: "Customer Subscribers List",
    path: "/customers-list",
  },
  {
    id: allBankViews["customers-groups"],
    name: "Customer Groups List",
    path: "/customers-groups",
  },
  {
    id: allBankViews["generated-notifications"],
    name: "Following on Generated Notifications",
    path: "/generated-notifications",
  },
];
export const AlertsRoutes = [
  "/alerts-settings",
  "/internal-alerts",
  "/customers-list",
  "/generated-notifications",
  "/customers-groups",
];

export const MatchingMenu = [
  {
    id: allBankViews["matching-rules"],
    name: "Matching Rules",
    path: "/matching-rules",
  },
  {
    id: allBankViews["matching-day"],
    name: "Mathcing Day",
    path: "/matching-day",
  },
];
export const MatchingRoutes = ["/matching-day", "/matching-rules"];

export const AdminToolMenu = [
  {
    id: allBankViews["bank-settings"],
    name: "Bank Settings",
    path: "/admin-tool/bank-settings",
  },
  {
    id: allBankViews["alerts-notifications"],
    name: "Alerts & Notifications",
    path: "/admin-tool/alerts-notifications",
  },
  {
    id: allBankViews["search-archive-settings"],
    name: "Search & Archive",
    path: "/admin-tool/search-archive",
  },
];
export const AdminToolRoutes = [
  "/admin-tool/bank-settings",
  "/admin-tool/alerts-notifications",
  "/admin-tool/search-archive",
];

export const UserManagementMenu = [
  { id: "Users", name: "Users", path: "/user-management/users" },
];
export const UserManagementRoutes = ["/user-management/users"];

export const AdminMenu = [
  {
    id: allSuperAdminViews.dashboard,
    icon: <HomeIcon fontSize="small" />,
    name: "Dashboard",
    path: "/admin",
  },
  {
    id: allSuperAdminViews.license,
    icon: <KeyIcon fontSize="small" />,
    name: "License Generation",
    path: "/admin/license",
  },
];

//messages' bands
export const messageBands = [
  { id: "Band 1", value: "200", label: "200" },
  { id: "Band 2", value: "500", label: "500" },
  { id: "Band 3", value: "1,000", label: "1,000" },
  { id: "Band 4", value: "2,000", label: "2,000" },
  { id: "Band 5", value: "3,000", label: "3,000" },
  { id: "Band 6", value: "6,000", label: "6,000" },
  { id: "Band 7", value: "12,000", label: "12,000" },
  { id: "Band 8", value: "20,000", label: "20,000" },
  { id: "Band 9", value: "40,000", label: "40,000" },
  { id: "Band 10", value: "60,000", label: "60,000" },
  { id: "Band 11", value: "200,000", label: "200,000" },
  { id: "Band 12", value: "400,000", label: "400,000" },
  { id: "Band 13", value: "600,000", label: "600,000" },
  { id: "Band 14", value: "1,200,000", label: "1,200,000" },
  { id: "Band 15", value: "1,200,000+", label: "1,200,000+" },
];
